import React, { createContext, useState } from "react";
export const FilterContext = createContext();

const FilterProvider = ({ children }) => {
  const [filterData, setFilterData] = useState({
    sortBy: "name",
    sortOrder: "asc",
  });

  return (
    <FilterContext.Provider
      value={{
        filterData,
        setFilterData,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export default FilterProvider;
